/**
 * EN TILSTAND SOM IKKE KREVER NOE (ARTISTS.md §0.4).
 *
 * ---------------------------------------------------------------------------------------------
 * Atle, 10. september: «Colour is for states that need action. Available, Hold, Confirmed and
 * Unavailable get a pill. Everything neutral — Not answered, Asked, Not listed — drops to muted
 * text with a small hollow dot. The current wall of identical grey pills is what this replaces.»
 *
 * DET ER EN REGEL OM OPPMERKSOMHET, ikke om farge. Fjorten grå merkelapper under hverandre bruker
 * like mye blekk som fjorten grønne, og da har merkelappen sluttet å bety «se her» — den er bare
 * formen alle celler har. Når bare de fire tilstandene som krever en handling bærer en pille, er
 * en pille igjen et signal.
 *
 * ---------------------------------------------------------------------------------------------
 * PRIKKEN ER HUL, OG DEN ER IKKE TOM PYNT.
 *
 * Uten den ville en ubesvart rad vært ren tekst, og da forsvinner kolonnen: øyet finner ikke igjen
 * hvor statusen står når halve kolonnen er merkelapper og halve er setninger. Den hule ringen
 * holder plassen og sier «det finnes en tilstand her, den er bare ikke rød».
 *
 * Formen bærer forskjellen alene (DESIGN.md §3): fylt pille mot hul ring skilles med fargen av.
 */
import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface QuietStateProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function QuietState({
  children,
  className,
  'data-testid': testId,
}: QuietStateProps): ReactNode {
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-sm text-subtle', className)}
      data-testid={testId}
    >
      <span aria-hidden className="size-1.5 shrink-0 rounded-full border border-subtle" />
      {children}
    </span>
  );
}
